<template>
  <table
    class="fts-table-view fts-table fts-table-striped"
    :class="{ 'fts-table-extended': getAttachmentColumns.length }"
    v-if="list && list.length"
  >
    <thead>
      <tr>
        <th class="row-checkbox" v-if="bulk">
          <checkbox
            v-model="selectedAll"
            :color="'#279ec6'"
            :size="16"
          ></checkbox>
        </th>
        <th
          v-for="column in getColumns"
          :key="column.id"
          :style="customColumnStyle(column)"
          :class="column.classes"
        >
          <div class="col-header">
            <fts-moji
              :emoji="moduleEmoji(column.connectionId)"
              :size="14"
              class="col-header-emoji"
              v-if="column.connectionId && moduleEmoji(column.connectionId)"
            />
            <i
              class="col-header-icon"
              :class="informationIcon(column.type)"
              v-else-if="informationIcon(column.type)"
            />
            <div class="col-header-name">
              {{ column.label || column.displayName }}
            </div>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <template v-for="item in list">
        <tr
          :key="item.id"
          @click="selectRow(item)"
          class="table-view-tr"
          :class="{ 'selected-row': item.selected }"
        >
          <td class="row-checkbox" v-if="bulk">
            <!-- todo remove stop -->
            <div @click.stop>
              <checkbox v-model="item.selected" :color="'#279ec6'" :size="16" />
            </div>
          </td>

          <td
            v-for="column in getColumns"
            :key="column.id"
            class="table-view-td"
            :class="[
              {
                'custom-col-w': customColumnStyle(column),
                'primary-col': column.primaryField,
                'wrap-col': column.wrap,
              },
              column.classes,
            ]"
            :style="customColumnStyle(column)"
          >
            <template v-if="column.system">
              <!-- document id -->
              <div
                class="col-document-id"
                v-if="column.fieldName === 'documentId'"
              >
                {{ item.documentId }}
              </div>
              <!-- collaboration -->
              <div
                class="fts-collaboration"
                v-if="commentRight && column.fieldName === 'collaboration'"
              >
                <!-- intention -->
                <div
                  class="collaboration-wrapper"
                  v-if="item.lastIntention && item.lastIntention.id"
                >
                  <fts-tippy
                    :options="{ theme: 'light-border' }"
                    :request="{
                      dispatchName: 'loadHistory',
                      payload: {
                        id: item.lastIntention.id,
                        type: 'intention',
                      },
                    }"
                  >
                    <div
                      slot="trigger"
                      class="collaboration-trigger collaboration-intention"
                      :class="{
                        'collaboration-last':
                          (item.collaborationFlags & 8) === 8,
                      }"
                    >
                      <i class="fts-icon-exclamation-triangle" />
                    </div>
                    <div
                      slot="content"
                      slot-scope="collaboration"
                      class="fts-collaboration-content"
                    >
                      <div class="collaboration-intention-content">
                        <div class="collaboration-intention-label">
                          Reported by
                        </div>
                        <fts-profile :userName="collaboration.createdBy" />
                      </div>
                      <div class="collaboration-date">
                        {{ moment(collaboration.createdDate).format("llll") }}
                      </div>
                    </div>
                  </fts-tippy>
                </div>
                <!-- comment -->
                <div
                  class="collaboration-wrapper"
                  v-if="item.lastComment && item.lastComment.id"
                >
                  <fts-tippy
                    :options="{ theme: 'light-border' }"
                    :request="{
                      dispatchName: 'loadHistory',
                      payload: {
                        id: item.lastComment.id,
                        type: item.lastComment.type
                          ? item.lastComment.type
                          : 'comment',
                      },
                    }"
                  >
                    <div
                      slot="trigger"
                      class="collaboration-trigger collaboration-comment"
                      :class="{
                        'collaboration-last':
                          (item.collaborationFlags & 4) === 4,
                      }"
                    >
                      <i class="fts-icon-comment" />
                    </div>
                    <div
                      slot="content"
                      slot-scope="collaboration"
                      class="fts-collaboration-content"
                    >
                      <div class="collaboration-comment-audit">
                        <fts-profile :userName="collaboration.createdBy" />
                        <div class="comment-from-now">
                          {{ momentRelativeTime(collaboration.createdDate) }}
                        </div>
                      </div>
                      <div
                        class="collaboration-comment-content"
                        v-html="collaboration.detail"
                      ></div>
                      <div class="collaboration-date">
                        {{ moment(collaboration.createdDate).format("llll") }}
                      </div>
                    </div>
                  </fts-tippy>
                  <div class="collaboration-count" v-if="item.commentCount">
                    {{ item.commentCount }}
                  </div>
                </div>
              </div>
              <!-- state -->
              <fts-state
                :state="item.state"
                v-else-if="column.fieldName === 'state'"
              />
              <!-- system date -->
              <div v-else-if="column.fieldName === 'date'">
                {{ moment(item.date).format("ll") }}
              </div>
              <!-- created date -->
              <div v-else-if="column.fieldName === 'createdDate'">
                {{ moment(item.audit.createdDate).format("llll") }}
              </div>
              <!-- created By -->
              <div
                class="fts-audit"
                v-else-if="column.fieldName === 'createdBy'"
              >
                <fts-profile
                  :userName="item.audit.createdBy"
                  class="audit-profile"
                />
                <fts-tippy
                  class="audit-date-wrapper"
                  :content="moment(item.audit.createdDate).format('llll')"
                >
                  <div slot="trigger" class="audit-date">
                    {{ momentRelativeTime(item.audit.createdDate) }}
                  </div>
                </fts-tippy>
              </div>
              <!-- updated date -->
              <div v-else-if="column.fieldName === 'lastChangeDate'">
                {{ moment(item.audit.updatedDate).format("llll") }}
              </div>
              <!-- updated by -->
              <div
                class="fts-audit"
                v-else-if="column.fieldName === 'lastChangeBy'"
              >
                <fts-profile
                  :userName="item.audit.updatedBy"
                  class="audit-profile"
                />
                <fts-tippy
                  class="audit-date-wrapper"
                  :content="moment(item.audit.updatedDate).format('llll')"
                >
                  <div slot="trigger" class="audit-date">
                    {{ momentRelativeTime(item.audit.updatedDate) }}
                  </div>
                </fts-tippy>
              </div>
              <!-- assign to -->
              <fts-assign-to
                :formData="item"
                :view-mode="!assignRight"
                :comment-section="commentRight"
                class="stopPropagation"
                @refresh="refresh"
                v-else-if="column.fieldName === 'assignTo'"
              />
              <!-- username -->
              <div v-else-if="column.fieldName === 'username'">
                <fts-profile :userName="item.extension.username" v-if="item.extension && item.extension.username">
                  <template #profileName={userProfileUsername}>
                    {{userProfileUsername}}
                  </template>
                </fts-profile>
              </div>
            </template>
            <!-- form element -->
            <fts-list-view-display
              :formData="item.extension || item"
              :item="column"
              :vectorId="vectorId"
              :list="listId"
              v-else
            />
            <!-- shortcut action -->
            <div
              class="sch-action stopPropagation"
              v-if="column.primaryField && viewRight"
            >
              <!-- view / quick view -->
              <fts-btn-hold
                tag="a"
                sm
                text
                :href="locusUrl(item.id)"
                text-transform-init
                box-shadow-none
                @clickEvent="executeActivity({ id: 'quickView' }, [item])"
                @longPressEvent="executeActivity({ id: 'view' }, [item], true)"
                v-if="fullViewRight"
              >
                <i class="fts-icon-file" />View
              </fts-btn-hold>
              <!-- quick view -->
              <fts-btn
                tag="a"
                sm
                text
                :href="locusUrl(item.id)"
                text-transform-init
                box-shadow-none
                @click="executeActivity({ id: 'quickView' }, [item])"
                v-else
              >
                <i class="fts-icon-file" />View
              </fts-btn>
            </div>
            <!-- standard menu -->
            <fts-standard-menu
              :item="item"
              :standardActions="standardActions"
              :moduleId="vectorId"
              :listId="listId"
              @executed="
                executeActivity(
                  $event,
                  list.filter((x) => x.selected)
                )
              "
              class="standard-menu stopPropagation"
              v-if="
                !bulk &&
                item.selected &&
                column.primaryField 
              "
            />
          </td>
        </tr>
        <!-- Attachments Row -->
        <tr
          :key="`tr-extended-${item.id}`"
          v-if="getAttachmentColumns.length"
          @click="selectRow(item)"
          :class="{ 'selected-row': item.selected }"
        >
          <td class="sub-row" v-if="bulk"></td>
          <td class="sub-row" :colspan="getColumns.length">
            <div class="col-file-container">
              <template v-for="attachmentColumn in getAttachmentColumns">
                <template
                  v-if="
                    getAttachmentModel(
                      item.extension || item,
                      attachmentColumn.fieldName
                    )
                  "
                >
                  <fts-file
                    v-for="file in getAttachmentModel(
                      item.extension || item,
                      attachmentColumn.fieldName
                    )"
                    :key="file.key"
                    :prefixURL="`${vectorId}-${attachmentColumn.id}`"
                    :data="file"
                    fileType="file"
                    downloadable
                    class="col-file-wrapper"
                  />
                </template>
              </template>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
    <!-- <tfoot>
    </tfoot> -->
  </table>
</template>

<script>
import moment from "moment";
import commons from "../../commons/commons";
import { store as canvasDesignStore } from "../../store/canvasDesignStore";

import FTSMoji from "../FTSMoji";
import FTSTippy from "../FTSTippy";
import FTSProfile from "../FTSProfile";
import FTSState from "../FTSState";
import FTSAssignTo from "../FTSAssignTo";
import FTSStandardMenu from "../FTSStandardMenu";
import FTSFile from "../file/FTSFile";
import FTSBtnHold from "../FTSBtnHold";
import FTSBtn from "../FTSBtn";

import Checkbox from "vue-material-checkbox";

export default {
  props: {
    bulk: Boolean,
    collaboration: Boolean,
    attachmentsRow: Boolean,
    editable: Boolean,
    vectorId: [String, Number],
    listId: String,
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    standardActions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    "fts-moji": FTSMoji,
    "fts-tippy": FTSTippy,
    "fts-profile": FTSProfile,
    "fts-state": FTSState,
    "fts-assign-to": FTSAssignTo,
    "fts-standard-menu": FTSStandardMenu,
    "fts-file": FTSFile,
    "fts-btn-hold": FTSBtnHold,
    "fts-btn": FTSBtn,
    checkbox: Checkbox,
  },
  methods: {
    moment,
    momentRelativeTime(date) {
      return commons.momentRelativeTime(date);
    },
    informationIcon(typeId) {
      return commons.informationIcon(typeId);
    },
    moduleEmoji(connectionId) {
      try {
        return this.modules.find((x) => x.id == connectionId).emoji;
      } catch (err) {}
    },
    customColumnStyle(column) {
      const systemDefaultCols = [
        { fieldName: "createdBy" },
        { fieldName: "lastChangeBy" },
        { fieldName: "assignTo", maxWidth: 200 },
      ];

      if (column.width) {
        const width = `${
          column.primaryField && column.width < 100 ? 100 : column.width
        }px`;
        return {
          width: width,
          minWidth: width,
          maxWidth: width,
        };
      } else if (column.system) {
        const systemDefaultCol = systemDefaultCols.find(
          (x) => x.fieldName === column.fieldName
        );
        if (systemDefaultCol)
          return { maxWidth: `${systemDefaultCol.maxWidth || 150}px` };
      }
    },
    locusUrl(id) {
      return commons.clientPathUrl({
        moduleId: this.vectorId,
        listId: this.listId,
        id: id,
      });
    },
    selectRow(item) {
      if (!this.editable || commons.elementStopPropagation()) return;

      if (!this.bulk) {
        this.list.forEach((x) => {
          if (x.selected && x.id !== item.id) this.$delete(x, "selected");
        });
      }

      if (!item.selected) this.$set(item, "selected", true);
      else this.$delete(item, "selected");
    },
    hoverRow(item) {
      if (!item.hovered) this.$set(item, "hovered", true);
      else this.$delete(item, "hovered");
    },
    executeActivity(activity, items, fullView) {
      this.$emit("activityExecuted", {
        activity: activity,
        items: items,
        fullView: fullView,
      });
    },
    getAttachmentModel(formData, columnFieldName) {
      const result = commons.model(formData, columnFieldName);
      if (result) return Array.isArray(result) ? result : [result];
    },
    refresh() {
      this.$emit("refresh");
    },
  },
  computed: {
    // rights
    viewRight() {
      return (
        this.standardActions.indexOf("view") > -1 ||
        this.standardActions.indexOf("quickView") > -1
      );
    },
    fullViewRight() {
      return this.standardActions.indexOf("view") > -1;
    },
    assignRight() {
      return this.standardActions.indexOf("assign") > -1;
    },
    commentRight() {
      return this.standardActions.indexOf("comment") > -1;
    },
    modules() {
      try {
        return canvasDesignStore.state.workspace.menus;
      } catch (err) {}

      return [];
    },
    getColumns() {
      let columns = [...this.columns];
      /* exclude attachments */
      if (this.attachmentsRow)
        columns = columns.filter(
          (col) => col.type !== 11 && col.type !== 12 && col.type !== 13
        );
      /* exclude hidden */
      columns = columns.filter(
        (col) =>
          (col.show === null || col.show === undefined || col.show === true) &&
          (col.hide === null || col.hide === undefined || col.hide !== true)
      );
      /* collaboration */
      if (columns.length && this.collaboration) {
        columns.splice(1, 0, {
          id: "collaboration",
          fieldName: "collaboration",
          system: true,
          classes: "collaboration-col",
        });
      }

      return columns;
    },
    getAttachmentColumns() {
      if (this.attachmentsRow)
        return this.columns.filter(
          (col) =>
            (col.type === 11 || col.type === 12 || col.type === 13) &&
            (col.show === null ||
              col.show === undefined ||
              col.show === true) &&
            (col.hide === null || col.hide === undefined || col.hide !== true)
        );
      return [];
    },
    selectedAll: {
      get() {
        return lodash.every(this.list, "selected");
      },
      set(val) {
        this.list.forEach((x) => {
          this.$set(x, "selected", val);
        });
      },
    },
    selection() {
      return this.list.filter((x) => x.selected);
    },
  },
  watch: {
    selection() {
      this.$emit("selectionChanged", this.selection);
    },
  },
  beforeCreate: function () {
    this.$options.components.FtsListViewDisplay =
      require("../FTSListViewDisplay").default;
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-table-view {
  .table-view-tr {
    &:hover {
      .table-view-td {
        &.primary-col .sch-action {
          display: block;
        }
      }
      .col-document-id {
        a {
          color: $primaryColor;
        }
      }
    }
  }
  .table-view-td {
    &:not(.custom-col-w):not(.wrap-col) {
      white-space: nowrap;
      // temp => wait for list view display phase change
      .location-name {
        white-space: nowrap;
      }
    }
    &.primary-col {
      position: relative;
      padding-right: 1.25rem;
      &:not(.custom-col-w) {
        min-width: 150px;
      }
      .standard-menu {
        position: absolute;
        top: 0.375rem;
        right: 0;
      }
      .sch-action {
        @include user-select-none;
        display: none;
        position: absolute;
        top: 0.2rem;
        transform: translateX(90%);
        box-shadow: var(--fts-elevation-2);
        border-radius: 0.25rem;
        background: var(--fts-popover-background);
        > .fts-btn {
          padding: 0.175rem 0.375rem;
          min-height: 0;
          height: auto;
          line-height: 1.5;
        }
      }
    }
    &.collaboration-col {
      max-width: 100px;
    }
    .col-document-id {
      font-weight: 500;
      a {
        color: initial;
        text-decoration: none;
      }
    }
  }
  .selected-row {
    .table-view-td {
      .col-document-id {
        a {
          color: $primaryColor;
          text-decoration: underline;
        }
      }
    }
  }

  // Override
  .row-checkbox {
    width: 1px;
    line-height: initial;
    .m-chckbox--container {
      width: initial;
      margin: 1.5px 0 0;
      .m-chckbox--label {
        display: none;
      }
    }
  }
}
</style>